import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { apiErrorMessage } from '../../utils/apiError';
import mcpServiceService from '../../services/mcpServiceService';
import IntegrateSystemsPage from '../IntegrateSystemsPage';

// ADMIN › PLATFORM › MCP AS A SERVICE › A SOURCE SYSTEM — /admin/mcp-service/sources/:sourceId (V643). The pipeline
// templates hconnect builds for one supported PMS, before any hotel has them: the same list as Pipelines
// (IntegrateSystemsPage, in its mcpSource mode), owned by the system rather than by the chain in the navbar. They are
// incorporated into a hotel's MCP as a Service offering later. Superadmin, like the rest of Admin.

export default function McpSourcePage() {
  const { sourceId } = useParams();
  const { isSuperAdmin } = useAuth();
  const [source, setSource] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isSuperAdmin) return;
    let cancelled = false;
    mcpServiceService.getSources()
      .then(d => {
        if (cancelled) return;
        const s = (d.sources || []).find(x => String(x.id) === String(sourceId));
        if (s) setSource(s); else setError('That system is not on the supported list.');
      })
      .catch(e => { if (!cancelled) setError(apiErrorMessage(e)); });
    return () => { cancelled = true; };
  }, [isSuperAdmin, sourceId]);

  // One object per system, so the list's loader does not refetch on every render.
  const mcpSource = useMemo(() => (source ? { id: source.id, name: source.name } : null), [source]);

  return (
    <div>
      <div style={{ padding: '1.25rem 2rem 0' }}>
        <Link to="/admin/mcp-service" style={{ fontSize: '0.875rem', color: '#4a6cf7', textDecoration: 'none' }}>← MCP as a Service</Link>
      </div>
      {!isSuperAdmin && <div className="error" style={{ margin: '1rem 2rem' }}>Only superadmins can manage MCP as a Service for the platform.</div>}
      {error && <div className="error" style={{ margin: '1rem 2rem' }}>{error}</div>}
      {isSuperAdmin && !error && !mcpSource && <p style={{ margin: '1rem 2rem', color: '#6b7280' }}>Loading…</p>}
      {mcpSource && <IntegrateSystemsPage mcpSource={mcpSource} />}
    </div>
  );
}
